<template>
  <div class="container-fluid">
    <div style="margin-bottom: 6px">
      <div>
        <div style="float: left;margin-top: 6px;margin-bottom: 6px">
          <b>{{total}}</b> audio
        </div>
        <!--<div style="float: right;margin-top: 6px;margin-bottom: 6px">
          <button class="btn btn-sm btn-primary" @click="toAdd()">New User</button>
        </div>-->
      </div>
      <el-table v-tb-height="{bottom:40,self:this}" :height="height" stripe border :data="list" empty-text="Temporarily no data">
        <el-table-column prop="dwn_id" label="ID"></el-table-column>
        <el-table-column prop="dwn_url" label="URL"></el-table-column>
        <el-table-column prop="dwn_en_name" label="EN Name"></el-table-column>
        <el-table-column prop="dwn_es_name" label="ES Name"></el-table-column>
        <el-table-column prop="dwn_duration" label="Duration"></el-table-column>
        <el-table-column prop="dwn_size" label="Size"></el-table-column>
        <!--<el-table-column prop="dwn_name" label="Name"></el-table-column>-->
        <el-table-column min-width="100px" label="Operator">
          <template slot-scope="scope">
            <a v-on:click="toUpdate(scope.row)"><i class="el-icon-s-data update"></i>Update</a>
          <!--  <a v-on:click="toDelete(scope.row)"><i class="el-icon-delete delete"></i>Delete</a>-->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div align="right">
      <div class="block">
        <el-pagination
          @current-change="handleCurrentChange"
          layout="prev, pager, next"
          :page-size="pageSize"
          :current-page="currentPage"
          :total="total">
        </el-pagination>
      </div>
    </div>

    <el-dialog title="Update White Noise" :visible.sync="editVisible" :fullscreen="false" width="450px" top="10vh"
               :destroy-on-close="true" :show-close="true" :close-on-click-modal="false" :close-on-press-escape="false">
      <WhiteNoiseUpdate v-if="editVisible" :chooseItem="chooseItem"
                        @closeDialog="editVisible=false" @dialogSucc="editSucc"></WhiteNoiseUpdate>
    </el-dialog>
  </div>
</template>

<script>
  import WhiteNoiseUpdate from './WhiteNoiseUpdate'

  export default {
    name: 'WhiteNoise',
    components: {WhiteNoiseUpdate},
    data () {
      return {
        list:  [
          /*{
            "dwn_id": 1,
            "dwn_url": "http://ota.aidoor.net/huiben/mp3/readcode/1000000000002/10021.mp3",
            "dwn_en_name": "en audio 1 ",
            "dwn_es_name": "es audio 1",
            "dwn_duration": 1,
            "dwn_size": 0,
            "dwn_name": "en audio 1 "
          }*/
        ],
        search: {
          name: '',
          id: ''
        },
        timer: 0,
        addVisible: false,
        editVisible: false,
        chooseId: 0,
        chooseItem: null,
        currentPage: 1,
        pageSize: 20,
        total: 0,
        height: 0
      }
    },
    created () {
      this.getData()
    },
    mounted () {
    },
    methods: {
      getData () {
        this.$api.rootV1.post('/web/whitenoise/get', {
          page: this.currentPage,
          size: this.pageSize
        }, (res) => {
          console.log('whitenoise res:', res)
          this.list = res.data
          this.total = res.totalCount * 1

        })
      },
      toAdd () {
        this.addVisible = true
      },
      addSucc () {
        this.addVisible = false
        this.getData()
      },
      toUpdate (row) {

        this.chooseId = row.version_id
        this.chooseItem = row
        this.editVisible = true
      },
      editSucc () {
        this.editVisible = false
        this.getData()
      },
      toDelete (row) {
        this.$confirm('This operation will delete the app version, do you want to continue?', 'prompt', {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(async () => {
          this.doDelete(row)
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'cancelled!'
          })
        })
      },
      doDelete (row) {
        const {version_id} = row
        let loading = this.$util.loading()
        this.$api.rootV1.post('/web/appversion/delete', {app_version_id: row.app_version_id}, (res) => {
          this.$message.success('successfully deleted!')
          this.getData()
          loading.close()
        }, (res) => {
          this.$message.error('failed to delete!')
          loading.close()
        })
      },
      handleCurrentChange (val) {
        console.log(`当前页: ${val}`)
        this.currentPage = val
        this.getData()
      },
    },
    watch: {}
  }
</script>

<style scoped>
  .a {
    position: relative;
    left: 10px;
  }
  .operator {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/main/whitenoise/WhiteNoise.vue